module.exports = __webpack_public_path__ + "fonts/IBMPlexSans-Regular.9c294c18.eot";